import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
} from "@faire/help-center-self-serve/types";
import { getSettingRetailerExclusivityAgreements } from "@faire/help-center-utils/settings/getSettingRetailerExclusivityAgreements";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getViewSingleOrMultipleInvoicesCTA } from "./shared";

export const WhereToFindInvoicesL3IA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (_context) => {
      return ACCESS_INVOICES(strictLocalize);
    },

    descriptionBuilder: (context) => {
      return getDescription(context, strictLocalize);
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getViewSingleOrMultipleInvoicesCTA(context, strictLocalize)
          ?.label;
      },
      linkBuilder: (context) => {
        return getViewSingleOrMultipleInvoicesCTA(
          context,
          strictLocalize
        )?.getLink?.(context.brandOrder);
      },
    },
  };
};

const getDescription = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): string[] => {
  const { brandOrder } = context;
  if (!brandOrder) {
    return [ACCESS_ANY_ORDER_INVOICE_USING_BUTTON(strictLocalize)];
  }

  return [ACCESS_ORDER_INVOICE_USING_BUTTON(strictLocalize)];
};

const ACCESS_INVOICES = (strictLocalize: StrictLocalizeFunction) => {
  if (getSettingRetailerExclusivityAgreements()) {
    return strictLocalize({
      defaultMessage: "How to find an invoice",
      description: {
        text: "Title for the answer of how to find an invoice",
      },
    });
  }
  return strictLocalize({
    defaultMessage: "Access invoices",
    description: {
      text: "Title for the answer of change shipping address for an order issue if the selected order has shipped",
    },
  });
};

const ACCESS_ANY_ORDER_INVOICE_USING_BUTTON = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "You can access the invoice for any order by clicking the button below.",
    description: {
      text: "Answer shown to users when they ask where to find invoices",
    },
  });

const ACCESS_ORDER_INVOICE_USING_BUTTON = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "You can access the invoice for the order that you selected by clicking the button below.",
    description: {
      text: "Answer shown to users when they ask where to find invoices",
    },
  });
